import * as React from "react";
import SideNavigation from "@amzn/awsui-components-react/polaris/side-navigation";
import Header from "@amzn/awsui-components-react/polaris/header";
import Box from "@amzn/awsui-components-react/polaris/box";
import Container from "@amzn/awsui-components-react/polaris/container";
import SpaceBetween from "@amzn/awsui-components-react/polaris/space-between";
import ColumnLayout from "@amzn/awsui-components-react/polaris/column-layout";
import { withRouter, RouteComponentProps } from "react-router-dom";
import PageShell from "../../../global/components/PageShell";

const TOOL_SECTIONS = [
    {
        text: "Customer Management",
        items: [
            { text: "Create Pharmacy Customer", href: "/create-pharmacy-customer" },
            { text: "Update Pharmacy Customer", href: "/update-pharmacy-customer" },
            { text: "Search Pharmacy Customer", href: "/search-pharmacy-customer" },
            { text: "Third Party Customer", href: "/third-party-customer" },
            { text: "Customer Journey", href: "/customer-journey" },
        ],
    },
    {
        text: "Prescriptions",
        items: [
            { text: "Manage Prescriptions", href: "/manage-prescriptions" },
            { text: "Prescription Ingestion", href: "/prescription-ingestion" },
            { text: "Consumption Guard", href: "/consumption-guard-override" },
            { text: "Copay Waiver", href: "/copay-waiver" },
            { text: "Claims Operations", href: "/claims" },
        ],
    },
    {
        text: "Orders & Shipments",
        items: [
            { text: "Shipment Operations", href: "/shipment-operations" },
        ],
    },
    {
        text: "Cached Customer Provider",
        items: [
            { text: "Cached Pharmacy Customer Provider", href: "/cached-pharmacy-customer-provider" },
            { text: "CPCP V2", href: "/cpcp-v2" },
        ],
    },
    {
        text: "PacMan & Enrollment",
        items: [
            { text: "PacMan", href: "/pacman" },
        ],
    },
    {
        text: "Other Tools",
        items: [
            { text: "Send Notifications", href: "/send-notifications" },
            { text: "Admin", href: "/admin" },
            { text: "HUBS", href: "/hubs" },
        ],
    },
];

interface State {
    navOpen: boolean;
}

class Page extends React.Component<RouteComponentProps, State> {
    constructor(props: RouteComponentProps) {
        super(props);
        this.state = { navOpen: true };
    }

    render() {
        return (
            <PageShell
                navigationOpen={this.state.navOpen}
                onNavigationChange={(open) => this.setState({ navOpen: open })}
                navigation={
                    <div style={{ fontSize: "16px" }}>
                        <SideNavigation
                            header={{
                                text: "APAQ Portal",
                                href: "/",
                            }}
                            activeHref={this.props.location.pathname}
                            onFollow={(e) => {
                                e.preventDefault();
                                this.props.history.push(e.detail.href);
                            }}
                            items={TOOL_SECTIONS.map((section) => ({
                                type: "section" as const,
                                text: section.text,
                                items: section.items.map((item) => ({
                                    type: "link" as const,
                                    text: item.text,
                                    href: item.href,
                                })),
                            }))}
                        />
                    </div>
                }
                content={
                    <div>
                        <Box padding={{ top: "l", bottom: "l" }}>
                            <Header
                                variant="h1"
                                description="Amazon Pharmacy - Assurance of Quality Team's Portal"
                            >
                                APAQ Portal
                            </Header>
                        </Box>
                        <SpaceBetween size="l">
                            <Container
                                header={<Header variant="h2">Welcome</Header>}
                            >
                                <SpaceBetween size="s">
                                    <Box variant="p">
                                        The APAQ Portal is a centralized QA tooling platform for Amazon Pharmacy.
                                        It provides test data management, customer provisioning, prescription lifecycle
                                        management, and integration testing capabilities for the pharmacy engineering teams.
                                    </Box>
                                    <Box variant="p">
                                        Use the navigation panel on the left to access the available tools, or explore
                                        the quick links below.
                                    </Box>
                                </SpaceBetween>
                            </Container>

                            <Container
                                header={<Header variant="h2">Quick Access</Header>}
                            >
                                <ColumnLayout columns={3} variant="text-grid">
                                    <div>
                                        <Box variant="h3" padding={{ bottom: "xs" }}>Customer Management</Box>
                                        <Box variant="p" color="text-body-secondary">
                                            Create, update, and search pharmacy test customers with configurable
                                            profiles, insurance, prescriptions, and orders.
                                        </Box>
                                    </div>
                                    <div>
                                        <Box variant="h3" padding={{ bottom: "xs" }}>Prescriptions & Orders</Box>
                                        <Box variant="p" color="text-body-secondary">
                                            Manage prescription lifecycles, ingest prescriptions, and execute
                                            shipment workflow operations for end-to-end testing.
                                        </Box>
                                    </div>
                                    <div>
                                        <Box variant="h3" padding={{ bottom: "xs" }}>PacMan & Enrollment</Box>
                                        <Box variant="p" color="text-body-secondary">
                                            Initiate and manage program enrollments, cached customer provisioning,
                                            packets enrollment, and schedule management.
                                        </Box>
                                    </div>
                                </ColumnLayout>
                            </Container>
                        </SpaceBetween>
                    </div>
                }
            />
        );
    }
}

export default withRouter(Page);
